module.exports = __webpack_public_path__ + "img/pr-7.7581dfa6.png";